import { useNavigate } from 'react-router-dom'
import { useAuth } from '../auth'

export default function NotAuthorized() {
  const navigate = useNavigate()
  const { signOut } = useAuth()

  function handleSignOut() {
    signOut()
    navigate('/')
  }

  return (
    <div className="wrap">
      <div className="brand">
        <div className="brand-logo">N73AA</div>
        <div className="brand-tag">Beechcraft Bonanza N35 &mdash; Logging</div>
      </div>

      <div className="card">
        <div className="msg msg-err">Not authorized</div>
        <p style={{ fontSize: '14px', color: '#3c4043', marginTop: 12 }}>
          Your Google account isn&apos;t on the N73AA partner list. Please
          contact the managing partner to be added.
        </p>
        <button className="btn btn-neutral" onClick={handleSignOut}>
          Sign out &amp; try a different account
        </button>
      </div>

      <div className="page-foot">N73AA partnership log.</div>
    </div>
  )
}
